import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Btn, Eyebrow, Reveal } from "@/components/Elements";
import { ABOUT_STATS, BIO_1, PHONE_DISPLAY, TEL_HREF, EMAIL, MAILTO } from "@/data/content";

const BIO_2 =
  "Unlike loan officers at traditional banks who are limited to a single institution's products, Joe shops the entire market on your behalf — comparing rates and programs across 320+ lenders to find the best fit for your unique situation. Joe closes in 9–16 days on average, reducing Rate Lock per diem costs and giving sellers confidence your deal will close. Based in Spring Hill, FL, Joe serves clients across Florida and nationally.";

export default function About() {
  return (
    <div>
      <Seo
        title="About Joe Spellman | Branch Manager & National Recruiter | Family First Mortgage USA"
        description="Meet Joe Spellman, Branch Manager of Family First Mortgage USA, powered by NEXA Lending — 320+ lenders, 9–16 day average closings, based in Spring Hill, FL."
      />
      <PageHeader
        eyebrow="Meet Your Advisor"
        line1="Joe Spellman —"
        line2="Branch Manager & National Recruiter"
        sub="Professional enough to inspire confidence, personal enough to make every client feel like family."
      />

      <section className="bg-white py-20 md:py-28" data-testid="about-body">
        <div className="wrap grid gap-16 lg:grid-cols-[440px_1fr] lg:gap-20">
          <Reveal className="relative mx-auto w-full max-w-md overflow-visible rounded-3xl bg-cream p-6 md:p-8 lg:mx-0 lg:self-start">
            <div
              className="relative aspect-square overflow-hidden rounded-full border-[3px] border-navy"
              data-testid="about-portrait"
            >
              <img
                src="/images/joe-spellman-headshot.jpg"
                alt="Joe Spellman, Branch Manager, Family First Mortgage USA"
                className="h-full w-full object-cover"
                style={{ objectPosition: "46% center" }}
              />
            </div>
            <span className="absolute bottom-5 right-5 h-7 w-7 rounded-md bg-gold" aria-hidden="true" />
            <div className="absolute bottom-6 left-4 max-w-[250px] rounded-2xl bg-navy p-5 shadow-[0_18px_45px_rgba(18,38,74,0.18)] md:p-6 lg:-left-6" data-testid="about-name-card">
              <h2 className="font-serif text-xl font-bold text-white">Joe Spellman</h2>
              <p className="mt-2 text-[10px] uppercase leading-relaxed tracking-[0.12em] text-mist">
                Branch NMLS #2729829 | Personal NMLS #2142845
              </p>
              <a
                href={TEL_HREF}
                data-testid="about-phone"
                className="mt-3 inline-block text-sm font-medium text-gold transition-colors hover:brightness-110"
              >
                {PHONE_DISPLAY}
              </a>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <Eyebrow>Biography</Eyebrow>
            <h2 className="mt-5 font-serif text-4xl font-bold tracking-tight text-navy sm:text-5xl">Joe Spellman</h2>
            <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.18em] text-gold">
              Branch Manager &amp; National Recruiter — NEXA Lending
            </p>
            <p className="mt-6 text-base leading-relaxed text-ink sm:text-lg">{BIO_1}</p>
            <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg">{BIO_2}</p>

            <blockquote className="mt-10 border-l-[3px] border-gold pl-6 font-serif text-xl italic leading-snug text-navy md:text-2xl" data-testid="about-pull-quote">
              &ldquo;My goal is simple — to make sure every client feels informed, respected, and confident from first
              call to closing day.&rdquo;
            </blockquote>

            <div className="mt-10 grid grid-cols-2 gap-4" data-testid="about-stats">
              {ABOUT_STATS.map((s) => (
                <div key={s.label} className="rounded-2xl bg-cream p-6">
                  <p className="font-serif text-3xl font-bold text-gold">{s.value}</p>
                  <p className="mt-1.5 text-[11px] uppercase tracking-[0.12em] text-ink">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <Btn variant="navy" href={TEL_HREF} testId="about-call-button">
                {PHONE_DISPLAY}
              </Btn>
              <Btn variant="outlineNavy" href={MAILTO} className="!text-[11px]" testId="about-email-button">
                {EMAIL}
              </Btn>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
